(function (angular) {

  angular.module("alk.places", []);

})(window.angular);


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-places/module.js